import { render, staticRenderFns } from "./activity-goods-list.vue?vue&type=template&id=6e4c6a39&scoped=true&"
import script from "./activity-goods-list.vue?vue&type=script&lang=js&"
export * from "./activity-goods-list.vue?vue&type=script&lang=js&"
import style0 from "./activity-goods-list.vue?vue&type=style&index=0&id=6e4c6a39&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e4c6a39",
  null
  
)

export default component.exports